/* AagamStuti refinements script. Plain JavaScript, no libraries. Loaded after aagamstuti.js.
   Adds: product and quote carousels, the campaign countdown, gallery zoom, the bundle builder, the delivery check and the menu drawer's extras.
   Adding to the bag is left to aagamstuti.js (it already handles [data-add-set] and [data-quick-add]). */
(function () {
  'use strict';

  var AS = window.AS || {};
  var doc = document;

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  function reduced() { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function once(el, key) { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; }

  /* ---------- Carousels: [data-carousel] with a .as-carousel__track and [data-prev] / [data-next] ---------- */
  function initCarousel(root) {
    if (!once(root, 'carReady')) return;
    var track = $('.as-carousel__track', root);
    var prev = $('[data-prev]', root), next = $('[data-next]', root);
    if (!track) return;
    function step() {
      var item = $('.as-carousel__item', track);
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    function paint() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      var overflow = track.scrollWidth > track.clientWidth + 2;
      var nav = $('.as-carousel__nav', root);
      if (nav) nav.hidden = !overflow;
    }
    function by(dir) { track.scrollBy({ left: dir * step(), behavior: reduced() ? 'auto' : 'smooth' }); }
    on(prev, 'click', function () { by(-1); });
    on(next, 'click', function () { by(1); });
    on(track, 'keydown', function (e) {
      if (e.target !== track) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); by(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); by(1); }
    });
    var raf = null;
    on(track, 'scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; paint(); }); }, { passive: true });
    on(window, 'resize', paint);
    paint();
  }

  /* ---------- Countdown: [data-countdown] with data-end (a date and time with an offset, such as 2026-11-08T23:59:00+05:30) ---------- */
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function initCountdown(root) {
    if (!once(root, 'cdReady')) return;
    var end = Date.parse(root.getAttribute('data-end') || '');
    if (isNaN(end)) { root.hidden = true; return; }
    var parts = {
      d: $('[data-cd="d"]', root), h: $('[data-cd="h"]', root), m: $('[data-cd="m"]', root), s: $('[data-cd="s"]', root)
    };
    var wrap = root.closest('[data-countdown-wrap]') || root;
    var done = $('[data-countdown-done]', wrap);
    var timer = null, lastLabel = -1;
    function finish() {
      if (timer) clearInterval(timer);
      root.hidden = true;
      var lead = $('[data-countdown-lead]', wrap);
      if (lead) lead.hidden = true;
      if (done) done.hidden = false;
    }
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { finish(); return; }
      var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
      if (parts.d) parts.d.textContent = pad(d);
      if (parts.h) parts.h.textContent = pad(h);
      if (parts.m) parts.m.textContent = pad(m);
      if (parts.s) parts.s.textContent = pad(s);
      var minuteKey = Math.floor(left / 60);
      if (minuteKey !== lastLabel) {
        lastLabel = minuteKey;
        root.setAttribute('aria-label', d + ' days, ' + h + ' hours and ' + m + ' minutes left');
      }
    }
    tick();
    timer = setInterval(tick, 1000);
    on(doc, 'visibilitychange', function () { if (!doc.hidden) tick(); });
  }

  /* ---------- Gallery zoom: look closer by moving the pointer over the large picture ---------- */
  function initZoom(stage) {
    if (!once(stage, 'zoomReady')) return;
    if (!(window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches)) return;
    function liveImage() { return $('.as-gal__slide:not([hidden]) > img', stage); }
    on(stage, 'mouseenter', function () { if (liveImage()) stage.classList.add('is-zoomed'); });
    on(stage, 'mouseleave', function () { stage.classList.remove('is-zoomed'); stage.style.removeProperty('--zx'); stage.style.removeProperty('--zy'); });
    on(stage, 'mousemove', function (e) {
      if (!stage.classList.contains('is-zoomed')) return;
      var r = stage.getBoundingClientRect();
      stage.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      stage.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
    });
  }

  /* ---------- Money, in the store's own format ---------- */
  function group(n, sep) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
  function money(cents) {
    var f = AS.moneyFormat || '{{amount}}';
    var whole = Math.floor(cents / 100), frac = ('0' + (cents % 100)).slice(-2);
    var withDec = function (thousand, dec) { var s = group(whole, thousand); return frac === '00' ? s : s + dec + frac; };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, name) {
      switch (name) {
        case 'amount': return withDec(',', '.');
        case 'amount_no_decimals': return group(whole, ',');
        case 'amount_with_comma_separator': return withDec('.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(whole, '.');
        case 'amount_with_apostrophe_separator': return withDec("'", '.');
        case 'amount_no_decimals_with_space_separator': return group(whole, ' ');
        case 'amount_with_space_separator': return withDec(' ', ',');
        default: return withDec(',', '.');
      }
    });
  }

  /* ---------- Bundle builder: [data-bundle]. Ticked pieces feed the existing [data-add-set] button ---------- */
  function initBundle(root) {
    if (!once(root, 'bbReady')) return;
    var inputs = $$('[data-bundle-item]', root);
    var total = $('[data-bundle-total]', root);
    var btn = $('[data-bundle-add]', root);
    var label = $('[data-bundle-label]', root);
    var note = $('[data-bundle-count]', root);
    function paint() {
      var sum = 0, ids = [];
      inputs.forEach(function (i) {
        if (i.checked && !i.disabled) { sum += Number(i.getAttribute('data-price')) || 0; ids.push(i.getAttribute('data-variant')); }
      });
      if (total) total.textContent = ids.length ? money(sum) : '';
      if (btn) {
        if (ids.length) { btn.setAttribute('data-add-set', ids.join(',')); btn.disabled = false; }
        else { btn.removeAttribute('data-add-set'); btn.disabled = true; }
      }
      if (label) label.textContent = ids.length === 0 ? 'Choose a piece' : ids.length === 1 ? 'Add 1 piece to bag' : 'Add ' + ids.length + ' pieces to bag';
      if (note) note.textContent = ids.length + ' of ' + inputs.filter(function (i) { return !i.disabled; }).length + ' chosen';
    }
    inputs.forEach(function (i) { on(i, 'change', paint); });
    paint();
  }

  /* ---------- Delivery check: [data-pincode] ---------- */
  function list(raw) {
    return String(raw || '').split(/[\s,;]+/).filter(function (x) { return /^\d{1,6}$/.test(x); });
  }
  function matches(code, entries) {
    return entries.some(function (e) { return code.indexOf(e) === 0; });
  }
  function initPincode(root) {
    if (!once(root, 'pcReady')) return;
    var input = $('[data-pincode-input]', root);
    var btn = $('[data-pincode-check]', root);
    var ok = $('[data-pc-ok]', root), no = $('[data-pc-no]', root), bad = $('[data-pc-bad]', root), hint = $('[data-pc-hint]', root);
    var allow = list(root.getAttribute('data-allow')), block = list(root.getAttribute('data-block'));
    function show(which, code) {
      [ok, no, bad].forEach(function (p) { if (p) p.hidden = p !== which; });
      if (hint) hint.hidden = !!which;
      $$('[data-pc-code]', root).forEach(function (el) { el.textContent = code; });
      if (input) input.setAttribute('aria-invalid', which === bad || which === no ? 'true' : 'false');
    }
    var etaEl = $('[data-pc-eta]', root);
    var dmin = parseInt(root.getAttribute('data-eta-min'), 10) || 0, dmax = parseInt(root.getAttribute('data-eta-max'), 10) || 0;
    function addDays(n) {
      var d = new Date(), left = n;
      while (left > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) left--; }
      return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
    }
    function eta() {
      if (!etaEl) return;
      if (dmin < 1) { etaEl.hidden = true; return; }
      if (dmax < dmin) dmax = dmin;
      etaEl.textContent = dmax === dmin ? 'Expected by ' + addDays(dmin) + '.' : 'Expected between ' + addDays(dmin) + ' and ' + addDays(dmax) + '.';
      etaEl.hidden = false;
    }
    function check() {
      var code = (input.value || '').replace(/\s+/g, '');
      if (!/^[1-9]\d{5}$/.test(code)) { show(bad, code); return; }
      var allowed = allow.length ? matches(code, allow) : true;
      var blocked = block.length ? matches(code, block) : false;
      var good = allowed && !blocked;
      show(good ? ok : no, code);
      if (good) eta();
      try { localStorage.setItem('as-pincode', code); } catch (e) { /* private mode: nothing to remember */ }
    }
    try {
      var saved = localStorage.getItem('as-pincode');
      if (saved && /^[1-9]\d{5}$/.test(saved) && input) { input.value = saved; check(); }
    } catch (e) { /* ignore */ }
    on(btn, 'click', check);
    on(input, 'keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(); } });
    on(input, 'input', function () {
      input.value = input.value.replace(/\D/g, '').slice(0, 6);
      if (input.getAttribute('aria-invalid') === 'true') { input.setAttribute('aria-invalid', 'false'); }
    });
  }

  /* ---------- Menu drawer: [data-menu]. Opening and closing belong to aagamstuti.js; this adds the saved count and swipe to close ---------- */
  function savedCount() {
    var n = 0;
    try { var l = JSON.parse(localStorage.getItem('as-wish') || '[]'); n = Array.isArray(l) ? l.length : 0; } catch (e) { n = 0; }
    return n;
  }
  function paintSaved() {
    var n = savedCount();
    $$('[data-saved-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }
  function initMenu(menu) {
    if (!once(menu, 'menuReady')) return;
    var panel = $('.as-sidenav__panel', menu);
    var x0 = 0, y0 = 0, tracking = false;
    on(panel, 'touchstart', function (e) {
      var t = e.touches[0];
      x0 = t.clientX; y0 = t.clientY; tracking = e.touches.length === 1;
    }, { passive: true });
    on(panel, 'touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      if (t.clientX - x0 > 70 && Math.abs(t.clientY - y0) < 45) {
        var close = $('.as-sidenav__close', menu);
        if (close) close.click();
      }
    }, { passive: true });
    on(doc, 'click', function (e) { if (e.target.closest('[data-menu-open]')) paintSaved(); });
    on(window, 'storage', function (e) { if (e.key === 'as-wish') paintSaved(); });
    paintSaved();
  }

  function boot(ctx) {
    $$('[data-carousel]', ctx).forEach(initCarousel);
    $$('[data-countdown]', ctx).forEach(initCountdown);
    $$('[data-zoom-stage]', ctx).forEach(initZoom);
    $$('[data-bundle]', ctx).forEach(initBundle);
    $$('[data-pincode]', ctx).forEach(initPincode);
    $$('[data-menu]', ctx).forEach(initMenu);
  }
  boot(doc);
  on(doc, 'shopify:section:load', function (e) { boot(e.target); });
})();
